// WidgetPanel.jsx
import React, { useState, useEffect, useRef } from 'react';
import { Icon, Button, TextArea } from "pepsico-ds";
import { ToastContainer, toast, Slide } from "react-toastify";
import { useToast } from '../../components/Toast/ToastContext';
import { useSelector, useDispatch } from 'react-redux'
import { FetchNpsKpiAction, CancelNpsKpiAction } from '../../redux/action/NpsAction';
import { useAuth } from "../../utils/auth/useAuth";
import Vector from '../../assets/Vector.png'
import ErrorIcon from '../../assets/ErrorIcon.svg'
import nps_logo from "../../../src/assets/nps_logo.svg";

const WidgetPanel = ({enablePostTimer, flag}) => {
  const { authState } = useAuth();
  const dispatch = useDispatch()
  const reasonRef = useRef(null);
  const improveRef = useRef(null);


  const { showToast } = useToast();


  const [isBlink, setIsBlink] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [selectedRating, setSelectedRating] = useState(null);
  const [isOpen, setIsOpen] = useState(enablePostTimer);
  const isNPSSubmittedRecently = useSelector((state) => state.localData.data.isNPSSubmittedRecently);
  const userDefaultRole = useSelector((state) => state.localData.data.userDefaultRole);
  const userEmailID = useSelector((state) => state.localData.data.userEmailID);
  const [animateBtn, setAnimateBtn] = useState(true);
  const npsResponseData = useSelector((state) => state.getNpsKpiReducer);

  const userData = useSelector((state) => state.getLandingPageReducer);

  const npsFeedbackDismissalAllowed = userData?.npsFeedbackDismissalAllowed || false;

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setAnimateBtn(false);
  //   }, 20000); // 20 seconds
 
  //   return () => clearTimeout(timer);
  // }, [animateBtn]);

  // 1. Trigger `animateBtn = true` every 10 minutes
// useEffect(() => {
//   const interval = setInterval(() => {
//     setAnimateBtn(true);
//   }, 10 * 60 * 1000); // 10 minutes

//   return () => clearInterval(interval);
// }, []); // empty dependency array means it runs only once on mount

// 2. Turn off animation 20 seconds after it becomes true
// useEffect(() => {
//   if (animateBtn) {
//     const timeout = setTimeout(() => {
//       setAnimateBtn(false);
//     }, 20000); // 20 seconds

//     return () => clearTimeout(timeout);
//   }
// }, [animateBtn]);

/* istanbul ignore next */
useEffect(() => {
  //npsFeedbackReminder-> false (no need to show popup)
  if (!userData?.npsFeedbackReminder) return;
  
  const loginTime = parseInt(localStorage.getItem("ph-login-time"), 10);
  const alreadyShown = localStorage.getItem("ph-nps-shown");

  if (!loginTime || alreadyShown) return;

  const SEVEN_MIN = 7 * 60 * 1000;
  const elapsed = Date.now() - loginTime;
  const remainingTime = SEVEN_MIN - elapsed;

  // If already past 7 minutes → show immediately
  if (remainingTime <= 0) {
    setIsOpen(true);
    localStorage.setItem("ph-nps-shown", "true");
    return;
  }

  // Otherwise wait only the remaining time
  const timer = setTimeout(() => {
    setIsOpen(true);
    localStorage.setItem("ph-nps-shown", "true");
  }, remainingTime);

  return () => clearTimeout(timer);
}, [userData]);


  
 
  // useEffect(() => {
  //   if (enablePostTimer) {
  //     setIsOpen(true);
  //   }
  // }, [enablePostTimer, flag]);
/* istanbul ignore next */
  useEffect(()=>{
    setSelectedRating(null)
  },[isOpen])
/* istanbul ignore next */
  useEffect(()=>{
    if(npsResponseData && npsResponseData?.type == "SUCCESS_NPS_DETAIL_VIEW_ACTION" && npsResponseData?.data == true){
      showToast('success', "Thanks for your feedback! Your responses have been submitted.", {
          icon: <img src={Vector} alt='image' style={{ width: '20px', height: '20px' }} />
      });
    }
    else if(npsResponseData && npsResponseData?.type == "SUCCESS_NPS_DETAIL_VIEW_ACTION" && !npsResponseData?.data){
      showToast('error', "You have already submitted.", {
          icon: <img src={ErrorIcon} alt='image' style={{ width: '20px', height: '20px' }} />
      });
    }
  }, [npsResponseData])

  /* istanbul ignore next */
  const handleSubmit = async() => {
    let npsRequest = {
      "userId" : userEmailID,
      "userPersona" : userDefaultRole,
      "npsScore" : selectedRating,
      "comment1" : reasonInput,
      "comment2" : improveInput
  }
    setIsOpen(!isOpen);
    setIsSubmit(true)
    if (selectedRating === null) {
      toast.error("Please select a rating before submitting.");
      return;
    }
    await dispatch(FetchNpsKpiAction(npsRequest))
  };
  /* istanbul ignore next */
  const getColorClass = (value) => {
    if (value <= 6) return "red";
    if (value <= 8) return "yellow";
    return "green";
  };

  // const togglePanel = (e) => {
  //   // localStorage.setItem('openModal', true)
  //   setIsOpen(!isOpen);
  // };
  /* istanbul ignore next */
  const cancelNPS = () => {
    // setReasonInputCount(0)
    // setImproveInputCount(0)
    // setReasonInput("")
    // setImproveInput("")
    setIsOpen(!isOpen);
    setIsBlink(true)
    setAnimateBtn(true)
    let npsCancelRequest = {
      "userId" : userEmailID
  }
   dispatch(CancelNpsKpiAction(npsCancelRequest))
  };
  /* istanbul ignore next */
  const validateForm = () => { // Returns true to Disable Submit Button
    if(reasonInputCount>500 || improveInputCount>500) { // || improveInput.trim().length==0 || reasonInput.trim().length==0
      return true;
    }
  };
  
  
  const [reasonInput, setReasonInput] = useState("");
  const [improveInput, setImproveInput] = useState("");
  const [reasonInputCount, setReasonInputCount] = useState(0);
  const [improveInputCount, setImproveInputCount] = useState(0);
  /* istanbul ignore next */
  useEffect(() => {
    const textarea = reasonRef.current?.querySelector('textarea');
    if (textarea) {
      textarea.style.height = 'auto';
      textarea.style.height = `${textarea.scrollHeight}px`;
    }
  }, [reasonInput]);
  /* istanbul ignore next */
  useEffect(() => {
    const textarea = improveRef.current?.querySelector('textarea');
    if (textarea) {
      textarea.style.height = 'auto';
      textarea.style.height = `${textarea.scrollHeight}px`;
    }
  }, [improveInput]);
  if(authState?.isAuthenticated){
    if(isNPSSubmittedRecently || isSubmit) {
      return null;
    }
    return (
      <>
        {/* Overlay */}
        {isOpen && (
          <>
          <div
          //   onClick={togglePanel} // Removed this not to close on click outside of sidepanel
          className={'widgetOverlay'}
          />
          </>
        )}
        {/* Sliding Panel */}
        
        <ToastContainer
                        containerId="widgetPanel"
                        position="bottom-right"
                        autoClose={5000}
                        toastClassName="custom-toast"
                        bodyClassName="custom-toast-body"
                        style={{
                          right: isOpen ? 0 : '-400px',
                        }}
                        transition={Slide}
                      //   className="toast-container"
                      />
        <div
            className={'widget-panel'}
            style={{
              right: isOpen ? 0 : '-400px',
            }}
          >
            <div style={{display: "flex", alignItems: "center", justifyContent: "space-between"}}>
              <h2 className='nps-survey-header'>We want to hear from you</h2>
              {
                npsFeedbackDismissalAllowed && (
                  <>
                    <Icon alt="" icon="close" size="medium" style={{cursor:"pointer"}} onClick={cancelNPS} 
                          aria-label="nps-cancel-button"
                          data-fs="nps-cancel-button"
                    />
                  </>
                )
              }
              
            </div>
  
            <div
              style={{
                flex: 1,
                // overflowY: 'auto',
                // padding: '20px 0',
              }}
            >
              
                    <>
                            {/* <ToastContainer
                        position="bottom-right"
                        autoClose={5000}
                        toastClassName="custom-toast"
                        bodyClassName="custom-toast-body"
                        transition={Slide}
                      //   className="toast-container"
                      /> */}
  
                      <div>
                              <span className='nps-question'>How likely are you to recommend Procurement Hub to a colleague? (1-10 scale)</span>
                      </div>
                      <div className="rating-wrapper">
                        <div className="rating-container">
                          {[...Array(10)].map((_, i) => {
                            const value = i + 1;
                            const isFaded = selectedRating !== null && selectedRating !== value;
                            return (
                              <button
                                key={value}
                                onClick={() => setSelectedRating(value)}
                                className={`rating-button ${getColorClass(value)} ${isFaded ? "faded" : ""}`}
                              >
                                {value}
                              </button>
                            );
                          })}
                        </div>
                        <div>
  
                
                </div>
                        {/* <button
                          onClick={handleSubmit}
                          className="submit-button"
                          disabled={selectedRating === null}
                        >
                          Submit
                        </button> */}
                      </div>
                    </>
                    <div style={{position:'relative', top: '-32px'}}>
                          <span style={{color: '#5c5858', fontSize: '14px'}}>😠 1 - Not likely</span>
                          <span style={{float: 'right', color:'#5c5858', fontSize: '14px'}} >10 - Extremely Likely 🙂</span>
                    </div>
                <div className="nps-field">
                    <div className='nps-question'>What is the primary reason for your score? <span className='optional-text'>Optional</span></div>
                    <div className='nps-input'>
                    <div ref={reasonRef}>
    <TextArea
      disableResize={true}
      feedbackType={reasonInputCount > 500 ? "error" : "info"}
      helperStyle={{}}
      helperText={`(${reasonInputCount}/500)`} 
      label=""
      onChange={(e) => {
        setReasonInput(e.target.value);
        setReasonInputCount(e.target.value.length);
      }}
      placeholder="Type Here"
      showCharacterCount={false}
      showLabelIcon={false}
      showToolbar={false}
      style={{
        overflow: 'hidden',
        minHeight: '40px',
      }}
      maxLength={500}
      value={reasonInput}
    />
  </div>
  
  
                    </div>  
                </div>
  
  
                <div className="nps-field">
                    <div className='nps-question'>What can we do to improve your experience? <span className='optional-text'>Optional</span></div>
                    <div className='nps-input'>
                      {/* Improve TextArea */}
  <div ref={improveRef}>
    <TextArea
      disableResize={true}
      feedbackType={improveInputCount > 500 ? "error" : "info"}
      helperStyle={{}}
      helperText={`(${improveInputCount}/500)`} 
      label=""
      onChange={(e) => {
        setImproveInput(e.target.value);
        setImproveInputCount(e.target.value.length);
      }}
      placeholder="Type Here"
      showCharacterCount={false}
      showLabelIcon={false}
      showToolbar={false}
      style={{
        overflow: 'hidden',
        minHeight: '40px',
      }}
      maxLength={500}
      value={improveInput}
    />
  </div>
                    </div>  
                </div>
                
            </div>
  
            <div
              style={{
                padding: '20px 0',
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '30px',
              }}
            >
              {
                npsFeedbackDismissalAllowed && (
                  <Button
                    size="medium"
                    text="Cancel"
                    variant="tertiary"
                    className='ph-cancel-nps-button'
                    onClick={cancelNPS}
                    aria-label="nps-cancel-button"
                    data-fs="nps-cancel-button"
                  />
                )
              }
              
              <Button
                size="medium"
                text="Submit"
                variant="primary"
                // disabled={validateForm()}
                // onClick={togglePanel}
                onClick={handleSubmit}
                className="ph-submit-button"
                disabled={selectedRating === null || validateForm()}
                aria-label="nps-submit-button"
                data-fs="nps-submit-button"
              />
            </div>
          </div>
  
  
        {/* Floating Button */}
        {/* { !isOpen && !isBlink ? <FloatingButton onClick={togglePanel} /> : <BlinkButton onClick={togglePanel} />} */}
        {/* {!isBlink && !isSubmit ? <FloatingButton onClick={togglePanel} animate={animateBtn} />:  isSubmit ? <></> : <BlinkButton onClick={togglePanel} />} */}
        {/* {!isOpen && !isSubmit && !isNPSSubmittedRecently ? <FloatingButton onClick={togglePanel} animate={animateBtn}/>: <></> } */}
        {/* {isNPSSubmittedRecently!==undefined && !isNPSSubmittedRecently && !isOpen && !isSubmit ? <FloatingButton onClick={togglePanel} animate={animateBtn}/>: <></> } */}
        {/* {!isOpen && !isNPSSubmittedRecently ? <FloatingButton onClick={togglePanel} animate={animateBtn}/>: <></> } */}
      </>
    );
  
            }

  
};

export default React.memo(WidgetPanel);
